import React from "react";
import style from "./Search.module.scss";
import debounce from "lodash.debounce";
import { CiSearch } from "react-icons/ci";
import { IoMdClose } from "react-icons/io";
import { useSelector, useDispatch } from "react-redux";
import { selectFilter, setSearch } from "../../redux/slices/filterSlice";

export default function Search() {
  const { search } = useSelector(selectFilter);
  const [value, setValue] = React.useState(search || "");
  const [activeInput, setActiveInput] = React.useState(false);
  const inputRef = React.useRef<HTMLInputElement>(null);

  const dispatch = useDispatch();

  const handlSetSearch: (value: string) => void = React.useCallback(
    (str) => {
      dispatch(setSearch(str));
    },
    [dispatch],
  );

  // Синхронизируем input с Redux state при изменении
  React.useEffect(() => {
    setValue(search || "");
  }, [search]);

  const clickInput = () => {
    setActiveInput(false);
    handlSetSearch("");
    setValue("");
    inputRef.current?.focus();
  };

  const updateInput = React.useMemo(
    () =>
      debounce((str: string) => {
        handlSetSearch(str);
      }, 1000),
    [handlSetSearch],
  );

  const changInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setValue(event.target.value);
    updateInput(event.target.value);
  };

  return (
    <div className={style.root}>
      <div className={style.media}>
        <CiSearch className={style.icon_seacrh} />
        <input
          ref={inputRef}
          className={style.inputs}
          placeholder='Введите название...'
          onChange={changInput}
          onClick={() => setActiveInput(true)}
          value={value}
          id='search'
          name='search'
        />
        <IoMdClose
          className={activeInput ? style.icon_close : style.non}
          onClick={() => clickInput()}
        />
      </div>
    </div>
  );
}
